import { Typography, Box, Fade } from '@mui/material';

import { useMessageCenterContext } from 'modules/IMC/MessageCenter/context';

function EmptyStateMessageList() {
    const { searchQuery } = useMessageCenterContext();
    return (
        <Fade in>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginX: 'auto',
                    paddingY: { xs: 4, sm: 6 },
                    paddingX: 2,
                }}>
                <Typography color="cement.500" variant="body1" textAlign="center">
                    {searchQuery ? 'No results found' : 'No messages to display'}
                </Typography>
            </Box>
        </Fade>
    );
}

export default EmptyStateMessageList;
